export default "__VITE_ASSET__BLvcQFsr__"